module.exports = __webpack_public_path__ + "src/app/images/badge-coming-soon2x.png?a76a2a89ae0175713107449e730f1258";